export const COUNTDOWN_MINUTES = 15; // min
export const STATUS_INTERVAL = 2000; // ms

export default {
    STATUS_INTERVAL,
    COUNTDOWN_MINUTES
};
